import React, { useState } from "react";
import "../../styles/Listing.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import ABAgriListing from "../../components/Checklists/Alberta/ABAgriListing.js";
import ABResidentialListing from "../../components/Checklists/Alberta/ABResidentialListing.js";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function Listing() {
  const [ListingType, setListingType] = useState("");

  let listingTemplate = "";
  if (ListingType === "Residential") {
    listingTemplate = <ABResidentialListing />;
  } else if (ListingType === "Agricultural") {
    listingTemplate = <ABAgriListing />;
  } else {
    listingTemplate = "";
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const setTemplate = (e) => {
    setListingType(e.target.value);
  };

  return (
    <div className="checklists flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-5">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 1, minWidth: 325, maxWidth: 110 }}>
              <InputLabel size="small" className="select-default-label">
                Listing Type
              </InputLabel>
              <Select
                value={ListingType}
                name="Listing Type"
                label="Listing Type"
                onChange={setTemplate}
                size="small"
                sx={{ borderRadius: 20 }}
                defaultValue="Single Family"
              >
                <MenuItem key={Math.random()} value="Residential">
                  For Sale (Residential)
                </MenuItem>
                <MenuItem key={Math.random()} value="Agricultural">
                  For Sale (Agricultural)
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>
      {listingTemplate}
    </div>
  );
}
